import { render, staticRenderFns } from "./PDFclienteInf.vue?vue&type=template&id=7df38c9e&scoped=true"
import script from "./PDFclienteInf.vue?vue&type=script&lang=js"
export * from "./PDFclienteInf.vue?vue&type=script&lang=js"
import style0 from "./PDFclienteInf.vue?vue&type=style&index=0&id=7df38c9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df38c9e",
  null
  
)

export default component.exports